import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { useReportContext } from 'lib/context/ReportContext/ReportContext';
import { filestackPath, formatDate } from 'lib/helpers/utility';
import useModal from 'lib/hooks/useModal';

import { currentPractice } from 'components/practice/practiceState';
import Typography from 'components/shared/Typography/Typography';

import CustomReportModal from './components/CustomReportModal';

const ReportDetails = () => {
  const location = useLocation();

  const practice = useRecoilValue(currentPractice);
  const { report, period, customReport } = useReportContext();

  const isAllDates = period?.key === 'all-dates';

  const showLogo = customReport?.header?.logo;
  const showHeaderName = customReport?.header?.reportTitle;
  const showPracticeName = customReport?.header?.practiceName;
  const showDateRange = customReport?.header?.reportPeriod;

  const { isOpen, openModal, closeModal } = useModal();

  useEffect(() => {
    if (location.state?.customize) openModal();
  }, [location.state?.customize, openModal]);

  const dateRange = useMemo(() => {
    if (isAllDates) return 'All Dates';

    const { start, end } = period?.value || {};

    if (start && end) {
      return `${formatDate(start, practice?.timezone)} - ${formatDate(end, practice?.timezone)}`;
    }
  }, [isAllDates, period?.value, practice?.timezone]);

  return (
    <div className="flex w-full flex-col items-center gap-3 bg-white py-3">
      {showLogo && (
        <img
          className="h-32 w-32 object-contain"
          src={filestackPath(JSON.parse(practice?.header_photo).jpg)}
        />
      )}
      {showHeaderName && (
        <Typography variant="h6" color="primary-800" className="!text-lg capitalize">
          {report?.name}
        </Typography>
      )}
      {showPracticeName && practice?.name && (
        <Typography variant="label" color="neutral-500">
          {practice?.displayName}
        </Typography>
      )}
      {showDateRange && dateRange && (
        <Typography variant="label" color="neutral-500">
          {dateRange}
        </Typography>
      )}

      {isOpen && <CustomReportModal name={report?.name} isOpen={isOpen} onClose={closeModal} />}
    </div>
  );
};

export default ReportDetails;
